import { actions } from './constants'

const initialState = {
  fetching: undefined,
  rules: undefined,
  fields: undefined,
  error: undefined,
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.FETCH:
      return {
        ...state,
        fetching: true,
      }

    case actions.FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fields: payload.fields,
      }

    case actions.FETCH_RULES_SUCCESS:
      return {
        ...state,
        rules: payload.rules,
      }

    case actions.FETCH_FAILURE:
    case actions.FETCH_RULES_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload.error,
      }

    case actions.SUBMIT_FAIL:
      return {
        ...state,
        error: payload.error,
      }

    case actions.CLOSE:
      return initialState

    default:
      return state
  }
}

export default reducer
